exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-form\r\n{\r\n    border: 1px solid #ddd;\r\n    background: #fff;\r\n    padding: 25px;\r\n    border-radius: 8px;\r\n    background-color: #eee;\r\n}\r\n.login-background\r\n{\r\n    margin-top: 20px; \r\n    padding: 30px 0;\r\n    \r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/login/login.component.css
// module id = ../../../../../src/app/_components/login/login.component.css
// module chunks = main